import autoTable from "jspdf-autotable";
import { drawGrandTotal } from "./dsadrawGrandTotalpdf";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;


    function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}



  const columnStyles = {
    // 0: { cellWidth: 40, halign: "left" },
   0: { cellWidth: 60, halign: "left" },
    1: { cellWidth: 60, halign: "right" },
    2: { cellWidth: 55, halign: "right" },
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP);
  doc.rect(14, startY - 10, 175, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
  doc.text(`Depot Number - ${shop}`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      // "Depot",
      "Allocation",
      "Debit",
      "Credit",
    ]],

    body: rows.map((r) => [
     // r.DEPOT,
      r.ALLOCATION,
      format(r.DEBIT.toFixed(2)),
      format(r.CREDIT.toFixed(2)),
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 175, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`DEPOT TOTAL - ${String(shop).trim()}`, 16, y + 5);

  // Debit Total
  doc.text(format(total.debit.toFixed(2)), 132, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.credit.toFixed(2)), 186, y + 5, {
    align: "right",
  });

  // Reset text color
  doc.setTextColor(0);

// Reserve space after Depot Total
doc.lastAutoTable.finalY = y +  5;
//                 rectangle height ^   ^ extra space
}



